import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { BorderRadius, Colors, FontSizes } from '../Theme';

const Tooltip = ({ children, error, position, width }) => {
  const [hovering, setHovering] = useState(false);
  const align_left = position.includes('left');
  const align_top = position.includes('top');
  const styles = {
    component: {
      display: 'inline-block',
      marginLeft: error && 'auto',
      position: 'relative'
    },
    content: {
      background: Colors.GRAY.hex,
      color: '#fff',
      fontSize: FontSizes.SMALL,
      padding: 20,
      position: 'absolute',
      zIndex: 2,
      top: align_top ? 0 : '50%',
      right: align_left ? 'auto' : -8,
      left: align_left ? -4 : 'auto',
      transform: `translate(${align_left ? '-100%' : '100%'}, ${align_top ? '-8px' : '-50%'})`,
      borderRadius: BorderRadius.DEFAULT,
      width: width || 200,
      boxShadow: '0px 20px 30px -15px rgba(0,0,0,0.5)',
      textAlign: 'left',
      lineHeight: '1.4em',
      whiteSpace: 'normal'
    },
    icon: {
      color: error ? Colors.RED.hex : Colors.GRAY.hex,
      fontSize: (error && 15) || 14,
      lineHeight: 1,
      margin: '0px 0px 0px 5px'
    },
    arrow: {
      width: 0,
      height: 0,
      borderTop: '6px solid transparent',
      borderBottom: '6px solid transparent',
      borderRight: align_left ? 'none' : `6px solid ${Colors.GRAY.hex}`,
      borderLeft: align_left ? `6px solid ${Colors.GRAY.hex}` : 'none',
      position: 'absolute',
      top: align_top ? 0 : '50%',
      left: align_left ? 'auto' : 0,
      right: align_left ? 0 : 'auto',
      transform: `translate(${align_left ? '100%' : '-100%'}, ${align_top ? '8px' : '-50%'})`
    }
  };

  return (
    <div
      onMouseEnter={setHovering.bind(null, true)}
      onMouseLeave={setHovering.bind(null, false)}
      style={styles.component}
    >
      <i
        className={(error && 'mdi mdi-alert-octagon') || 'mdi mdi-information-outline'}
        style={styles.icon}
      />

      {hovering ? (
        <div style={styles.content}>
          <div style={styles.arrow} />
          {children}
        </div>
      ) : null}
    </div>
  );
};

Tooltip.propTypes = {
  error: PropTypes.bool,
  position: PropTypes.oneOf(['left', 'right', 'left-top']),
  width: PropTypes.number
};

export default Tooltip;
